import { Disclosure } from "@headlessui/react";
import clsx from "clsx";

import { ArrowBackSVGIcon } from "components/SVGIcons";
import { IHelpFAQ } from "models/User";
import styles from "./style.module.scss";

interface IProps {
  data: IHelpFAQ;
}

export default function Accordion({ data }: Readonly<IProps>) {
  return (
    <Disclosure as="div">
      {({ open }) => (
        <>
          <Disclosure.Button className={styles.AccordionButton}>
            <span>{data.question}</span>
            <ArrowBackSVGIcon
              className={clsx("size-4 flex-none", open ? "-rotate-90 transform" : "")}
            />
          </Disclosure.Button>
          <Disclosure.Panel className={styles.AccordionPanel}>{data.answer}</Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
